module.exports = __webpack_public_path__ + "static/media/sweat-explore-taskbar.055a03ca.png";